import api from 'api'

export default class MessageHandler {

    currentDialog
    parentId
    editMessage
    isDraft
    statisticsData

    constructor(
        currentDialog,
        parentId,
        editMessage,
        isDraft = true,
        statisticsData = null
    ){
        this.currentDialog = currentDialog
        this.parentId = parentId
        this.editMessage = editMessage
        this.isDraft = isDraft
        this.statisticsData = statisticsData
    }

    prepareMessage() {
      let data = Object.assign({}, this.editMessage)
      data.draft = this.isDraft
      data.subject = this.currentDialog.subject
      data.rootId = this.currentDialog.id
      data.parentId = this.parentId
      data.body = this.editMessage.body

      if(!this.isDraft && this.statisticsData.statistics) {
        data.statistics = this.statisticsData.statistics
        data = {...data, ...this.statisticsData.formAdd}
      }

      return data
    }

    async sendMessage()
    {
        return await api.call(
          'sendMessage', 
          { id: this.editMessage.id, rootId: this.currentDialog.id }, 
          this.prepareMessage(),
          false
        )
    }

    async uploadAttachment(file) {
      const formData = new FormData();
      formData.append('fileList', file)
      return await api.call(
        'addAttachment', 
        { id: this.editMessage.id, rootId: this.currentDialog.id }, 
        formData,
        false,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
    }

    async deleteAttachment(file) {
      if(!file) {
        return
      }
      await api.call('deleteAttachment', 
      {
        rootId: this.currentDialog.id, 
        id: this.editMessage.id,
        attachmentId: file.id
      })
    }

    appendObjectToFormData(formData, data) 
    {
      for(let key in data) {
        formData.append(key, data[key])
      }
    }
}